export default "__VITE_ASSET__DLAV_tLF__"